import {
  createDivision,
  getAllDivisions,
  getDivisionById,
  updateDivisionById,
} from 'api/admin/division';

import { getAllDivisions as getAllDivisionsByCustomer } from 'api/customer/division';
import { getDivisionInStorage, setDivisionInStorage } from 'lib/Storage';

import { useSnackbar } from 'notistack';
import { useDivisionSetSate } from 'providers/DivisionProvider';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';

function useCreateDivision() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const setDivision = useDivisionSetSate();
  const history = useHistory();
  const localDivision = getDivisionInStorage();

  return useMutation(createDivision, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries('profile');
      setDivisionInStorage({ ...localDivision, selected: data?.saved });
      setDivision({ ...localDivision, selected: data?.saved });
      enqueueSnackbar('بخش جدید با موفقیت ایجاد شد.', { variant: 'success' });

      if (data?.status === 'OK') {
        history.push('/services');
      }
    },
  });
}

function useAllDivisions(query, options) {
  return useQuery(['divisions', query], () => getAllDivisions(query), { ...options });
}

function useAllDivisionsByCustomer(query, options) {
  return useQuery(['divisions', query], () => getAllDivisionsByCustomer(query), { ...options });
}

function useDivision(id) {
  return useQuery(['division', id], () => getDivisionById(id));
}

function useUpdateDivision() {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useMutation(updateDivisionById, {
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries();
      enqueueSnackbar('بخش با موفقیت ویرایش شد', { variant: 'success' });
    },
  });
}

export { useCreateDivision, useAllDivisions, useAllDivisionsByCustomer, useDivision, useUpdateDivision };
